import { render, staticRenderFns } from "./FiscalContactFormEditCfdi.vue?vue&type=template&id=53f391dc&scoped=true&"
import script from "./FiscalContactFormEditCfdi.vue?vue&type=script&lang=js&"
export * from "./FiscalContactFormEditCfdi.vue?vue&type=script&lang=js&"
import style0 from "./FiscalContactFormEditCfdi.vue?vue&type=style&index=0&id=53f391dc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53f391dc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCheckbox,VCol,VRow,VSelect,VTextField})
